// Core
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

// Styles
import "./styles.scss";

// Redux
import { useDispatch } from "react-redux";
import { logoutRequest } from "../../Redux/Slices/Common/commonSlice";
import { clearReportId } from "../../Redux/Slices/User/reportSlice";
import { getPendingtAssessment_USER } from "../../Redux/Slices/User/userSlice";

// Assets
import DashboardIcon from "../../Assets/Svg/Auth/SidebarDashboardIcon.svg";
import AssesmentIcon from "../../Assets/Svg/Auth/SidebarPreAssessment.svg";
import AdminAssesmentIcon from "../../Assets/Svg/Admin/AssessmentBacklog/logo.svg";
import StaffManagement from "../../Assets/Svg/Auth/SidebarStaffManagement.svg";
import Report from "../../Assets/Svg/Auth/SidebarReccomendation.svg";
import SettingsIcon from "../../Assets/Svg/Auth/SidebarSettings.svg";
import Logout from "../../Assets/Svg/Auth/Logout.svg";
import StoreAuditIcon from "../../Assets/Images/marketAnalysis.png"

// Custom component
import LogoutModal from "Components/LogoutModal";

const Drawer = () => {
  //Initialize redux
  const dispatch = useDispatch();

  // Initialize useNavigate
  const navigate = useNavigate();

  const [preAssessmentNotification, setPreAssessmentNotification] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const { pathname } = useLocation();

  //notification for pre assessment sidebar
  useEffect(() => {
    dispatch(
      getPendingtAssessment_USER({
        callBack: getSchuledAssessmentUsers,
      })
    );
  }, []);
  const getSchuledAssessmentUsers = (data) => {
    const count = data?.data?.datas.filter(
      (item) => item.percentage !== 100
    ).length;
    setPreAssessmentNotification(count);
  };
  // Sidebar menu items based on environment
  const menuItems = {
    //admin
    1: [
      { name: "Dashboard", icon: DashboardIcon, path: "/", notification: 0 },
      {
        name: "Assessment Backlog",
        icon: AdminAssesmentIcon,
        path: "/assessment-backlogs",
        notification: 0,
      },
      {
        name: "Contact Us",
        icon: AdminAssesmentIcon,
        path: "/contactUs",
        notification: 0,
      },
      { name: "Reports", icon: Report, path: "/reports", notification: 0 },
      {
        name: "Staff Management",
        icon: StaffManagement,
        path: "/staff-management",
        notification: 0,
      },
      {
        name: "Settings",
        icon: SettingsIcon,
        path: "/settings",
        notification: 0,
      },
    ],
    //assessor
    2: [
      { name: "Dashboard", icon: DashboardIcon, path: "/", notification: 0 },
      {
        name: "Assessment Tracker",
        icon: AssesmentIcon,
        path: "/assessment-tracker",
        notification: 0,
      },
      {
        name: "Conduct Assessment",
        icon: Report,
        path: "/assessment-review",
        notification: 0,
      },
      {
        name: "Store Audit",
        icon: StoreAuditIcon,
        path: "/store-audit",
        notification: 0,
      },
      {
        name: "Settings",
        icon: SettingsIcon,
        path: "/settings",
        notification: 0,
      },
    ],
    //Approver
    4: [{ name: "Approval", icon: DashboardIcon, path: "/", notification: 0 }],
    //user
    3: [
      { name: "Dashboard", icon: DashboardIcon, path: "/", notification: 0 },
      {
        name: "Pre-Assessment",
        icon: AssesmentIcon,
        path: "/pre-assessment",
        notification: preAssessmentNotification,
      },
      {
        name: "Recommendations",
        icon: Report,
        path: "/recommendations",
        notification: 0,
      },
      {
        name: "Settings",
        icon: SettingsIcon,
        path: "/settings",
        notification: 0,
      },
    ],
  };

  const handleLogout = () => {
    dispatch(
      logoutRequest({
        callBack: logoutRequestCB,
      })
    );
  };

  const logoutRequestCB = () => {
    localStorage?.removeItem("isLoggedIn", null);
    localStorage?.removeItem("userDetails", null);
    setIsModalOpen(false);
    navigate("/", { replace: true });
  };

  const isActive = (itemPath) => {
    if (itemPath === "/") {
      // Activate "/" for root and for any "/assessment" related path
      return pathname === "/" || pathname.startsWith("/dashboard")
        ? "active"
        : "";
    }
    return pathname.startsWith(itemPath) ? "active" : "";
  };

  return (
    <div className="drawer">
      <ul className="menu">
        {menuItems[userDetails?.role]?.map((item, index) => (
          <Link to={item.path} key={index} style={{ textDecoration: "none" }}>
            <li
              className={`menu-items ${isActive(item.path)}`}
              onClick={() => dispatch(clearReportId())}
            >
              <div className="menu-item">
                <img
                  src={item.icon}
                  className="menu-icon"
                  alt={item.name}
                  width="30"
                  height="30"
                />
                <span className="menu-text">{item.name}</span>
                <div
                  className={item.notification > 0 ? "badge" : "badge-hidden"}
                >
                  {item.notification}
                </div>
              </div>
            </li>
          </Link>
        ))}
        {/* logout button */}
        <Link style={{ textDecoration: "none" }}>
          <li className="menu-items" onClick={() => setIsModalOpen(true)}>
            <div className="menu-item">
              <img
                src={Logout}
                className="menu-icon"
                alt={"logout"}
                width="30"
                height="30"
              />
              <span className="menu-text">Logout</span>
            </div>
          </li>
        </Link>
      </ul>
      {/* logoutmodal component */}
      {isModalOpen && (
        <LogoutModal
          show={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          onLogout={handleLogout}
        />
      )}
    </div>
  );
};

export default Drawer;
